export default function WorkWithUs() {
  return (
    <section className="py-8">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">
        <div className="relative rounded-3xl overflow-hidden">

          {/* Mobile image */}
          <img
            src="/Frame5.jpg"
            alt="Work with us"
            className="w-full h-auto block sm:hidden"
          />

          {/* Desktop image */}
          <img
            src="/Frame9.jpg"
            alt="Work with us"
            className="w-full h-auto hidden sm:block"
          />

          {/* Mobile: invisible button overlay */}
          <a 
            href="/contact"
            className="absolute sm:hidden bottom-[12%] left-[8%] w-[60%] h-[14%] rounded-2xl cursor-pointer"
          >
            <span className="sr-only">Contact us</span>
          </a>

          {/* Desktop: invisible button overlay */}
          <a 
            href="/contact"
            className="absolute hidden sm:block right-[18%] top-[54%] w-[12%] h-[25%] rounded-full cursor-pointer"
          >
            <span className="sr-only">Contact us</span>
          </a>

        </div>
      </div>
    </section>
  );
}